import { useState } from "react";
import { toast } from "sonner";
import { Gift } from "lucide-react";
import { useApi } from "@/lib/useApi";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const PAY = {
  gratuit: ["Offert — aucun paiement", "bg-violet-50 text-violet-800 ring-violet-200"],
  en_attente: ["Paiement en attente", "bg-amber-50 text-amber-800 ring-amber-200"],
  confirme: ["Paiement confirmé", "bg-green-50 text-green-800 ring-green-200"],
  refuse: ["Paiement refusé", "bg-red-50 text-red-700 ring-red-200"],
  non_renseigne: ["Non renseigné", "bg-gray-100 text-gray-700 ring-gray-200"],
};

export const PaymentBadge = ({ status, testid }) => {
  const [label, cls] = PAY[status] || [status, "bg-gray-100 text-gray-700 ring-gray-200"];
  return <span data-testid={testid} className={`rounded-full px-2.5 py-0.5 text-xs font-semibold ring-1 ${cls}`}>{label}</span>;
};

export const OfferAccess = ({ shop, onDone }) => {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ plan: "economie", days: 14, note: "" });
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post(`/admin/shops/${shop.id}/offer`, { ...f, days: Number(f.days) });
      toast.success("Accès offert accordé (0 FCFA, aucun paiement enregistré)");
      setOpen(false); onDone();
    } catch (err) { toast.error(errMsg(err)); }
  };
  if (!open) return <Button size="sm" variant="outline" data-testid={`offer-open-${shop.slug}`} onClick={() => setOpen(true)}><Gift className="mr-1 h-4 w-4" />Offrir un accès</Button>;
  return (
    <form onSubmit={submit} data-testid={`offer-form-${shop.slug}`} className="flex w-full flex-wrap items-end gap-2 rounded-lg bg-violet-50 p-3 ring-1 ring-violet-200">
      <label className="text-xs font-semibold">Droits
        <select data-testid="offer-plan" value={f.plan} onChange={(e) => setF({ ...f, plan: e.target.value })} className="mt-1 block h-9 rounded-md border bg-white px-2 text-sm">
          <option value="economie">Niveau Économie</option><option value="premium">Niveau Premium</option>
        </select></label>
      <label className="text-xs font-semibold">Durée (jours)
        <Input data-testid="offer-days" type="number" min="1" max="365" required value={f.days} onChange={(e) => setF({ ...f, days: e.target.value })} className="mt-1 h-9 w-24 bg-white" /></label>
      <label className="min-w-[12rem] flex-1 text-xs font-semibold">Motif (essai, partenaire…)
        <Input data-testid="offer-note" required minLength={3} maxLength={300} value={f.note} onChange={(e) => setF({ ...f, note: e.target.value })} className="mt-1 h-9 bg-white" /></label>
      <Button size="sm" data-testid="offer-submit">Accorder gratuitement</Button>
      <Button size="sm" type="button" variant="ghost" onClick={() => setOpen(false)}>Annuler</Button>
      <p className="w-full text-xs text-violet-900">Enregistré comme « Offert — 0 FCFA », jamais comme un paiement vérifié. Retrait possible à tout moment.</p>
    </form>
  );
};

export const AiLimitsCard = () => {
  const { data, reload } = useApi("/admin/ai-limits");
  const [f, setF] = useState(null);
  const v = f || data;
  if (!v) return null;
  const save = async () => {
    try { await api.put("/admin/ai-limits", { economie: Number(v.economie), premium: Number(v.premium) }); toast.success("Limites IA enregistrées"); setF(null); reload(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div data-testid="ai-limits-card" className="flex flex-wrap items-end gap-3 rounded-xl border bg-white p-4 text-sm">
      <p className="w-full font-semibold">Limites IA par formule (fiches par mois, remises à zéro le 1er du mois)</p>
      {[["economie", "Économie"], ["premium", "Premium"]].map(([k, l]) => (
        <label key={k} className="text-xs font-semibold">{l}
          <Input data-testid={`ai-limit-${k}`} type="number" min="0" value={v[k]} onChange={(e) => setF({ ...v, [k]: e.target.value })} className="mt-1 h-9 w-28" /></label>
      ))}
      <Button size="sm" data-testid="ai-limits-save" disabled={!f} onClick={save}>Enregistrer</Button>
    </div>
  );
};
